import TechnicalAnalysisItem from './ArticlesItem';

export default TechnicalAnalysisItem;
